import { AuditAudio } from '@mi-front/core';
import { Box, Typography } from '@mui/material';
import { defineMessage } from 'react-intl';
import { AuditMatchAudio } from '../types';
import { VerifyMatchCreativePlayer } from './verify-match/VerifyMatchCreativePlayer';

const mediaTitleMessage = defineMessage({
  id: 'audit.audiosScreen.mediaTitle',
  defaultMessage: 'Media',
});

export interface ShowTranscriptionDialogContentProps {
  stationId: string;
  audio: Pick<AuditAudio, 'id' | 'customId' | 'title' | 'duration' | 'filename'>;
  transcription: NonNullable<AuditAudio['transcription']>;
}

/**
 * Transcription text plus media player so the user can check accuracy.
 */
export function ShowTranscriptionDialogContent({
  stationId,
  audio,
  transcription,
}: ShowTranscriptionDialogContentProps) {
  const creativeAudio: AuditMatchAudio = {
    customId: audio.customId,
    title: audio.title,
    duration: audio.duration,
    filename: audio.filename,
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography component="p" sx={{ whiteSpace: 'pre-wrap' }}>
        {transcription.content}
      </Typography>
      <VerifyMatchCreativePlayer
        stationId={stationId}
        audio={creativeAudio}
        mediaId={audio.id}
        title={mediaTitleMessage}
      />
    </Box>
  );
}
